import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { propFunc, propNumber, propArrayShape, } from '../../../../../../../../helpers/custom-prop-types';
const RfpOneDescriptionTabHead = (props) => {
    const { changeTabIndex, items, tabIndex } = props;
    const onClick = useCallback((e) => {
        changeTabIndex(parseInt(e.currentTarget.value, 10));
    }, [changeTabIndex]);
    return (_jsx("ul", Object.assign({ className: 'head_row' }, { children: items.map((item) => (_jsx("li", Object.assign({ className: clsx('head_column', item.id === tabIndex && 'is-active') }, { children: _jsx("button", Object.assign({ className: 'head_text', onClick: onClick, type: 'button', value: item.id }, { children: item.label })) }), item.id))) })));
};
RfpOneDescriptionTabHead.propTypes = {
    changeTabIndex: propFunc().isRequired,
    items: propArrayShape().isRequired,
    tabIndex: propNumber().isRequired,
};
export default RfpOneDescriptionTabHead;
